import { render } from "./FormHeadTrainingTable.vue?vue&type=template&id=0f9599cc&scoped=true&ts=true"
import script from "./FormHeadTrainingTable.vue?vue&type=script&lang=ts"
export * from "./FormHeadTrainingTable.vue?vue&type=script&lang=ts"

import "./FormHeadTrainingTable.vue?vue&type=style&index=0&id=0f9599cc&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9599cc"]])

export default __exports__